import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

document.addEventListener("DOMContentLoaded", (event) => {
  const element = document.getElementById('visican-complex-products');
  
  const root = ReactDOM.createRoot(element);
  root.render(
    <React.StrictMode>
      <App data={window.product_data} />
    </React.StrictMode>
  );

  reportWebVitals();
});
